import { createSlice } from '@reduxjs/toolkit';
import { fetchSurveys, fetchSurveysSelectByAdmin, logoutAdmin, logoutUser } from '~/api';

const initialState = [];

const surveysSlice = createSlice({
  name: 'surveys',
  initialState,
  reducers: {},
  // 非同期はextraReducersで行う
  extraReducers: {
    [fetchSurveys.fulfilled.type]: (state, action) => {
      return action.payload.result;
    },

    [fetchSurveysSelectByAdmin.fulfilled.type]: (state, action) => {
      return action.payload.result;
    },

    [logoutAdmin.fulfilled.type]: () => {
      return initialState;
    },

    [logoutUser.fulfilled.type]: () => {
      return initialState;
    },
  },
});

// reducerをexportする
export default surveysSlice.reducer;
